'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { usePathname } from '@/i18n/navigation';
import { findObjectById } from '@/utils/global';
import { event_sub_view_item_list, event_view_item_list } from '@/utils/gtm';
import NextImage from '@/components/ui/next-image';
import useCategoryStore from '@/store/category.store';
import { CategoriesSlider } from '@/components/ui/sliders';
import { extractCategoryId } from '@/utils/category';

function Header({ categoryId, isMobile, products }) {
  const pathname = usePathname();
  const { categoryTreeData, _hasHydrated } = useCategoryStore((state) => state);
  const currentCategory = findObjectById(
    categoryTreeData?.children_data || [],
    'id',
    categoryId
  );
  const categoryBannerImage =
    currentCategory?.['category_desktop_image1'] || currentCategory?.image;

  const subCategories =
    currentCategory?.children_data?.filter(
      (c) => c.is_active && c.include_in_menu == 1 && c?.product_count > 0
    ) || [];
  // For Category And sub Category Event
  useEffect(() => {
    if (currentCategory) {
      const pathnames = pathname.split('/').filter(Boolean);
      if (pathnames.length === 1) {
        event_view_item_list(currentCategory, products);
      } else {
        const parent_category = extractCategoryId([pathnames?.at(-2)]);
        const sub_category = extractCategoryId([pathnames?.at(-1)]);
        const parentData = findObjectById(
          categoryTreeData?.children_data || [],
          'id',
          parent_category
        );
        const subCategoryData = findObjectById(
          categoryTreeData?.children_data || [],
          'id',
          sub_category
        );
        event_sub_view_item_list(parentData, subCategoryData, products);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, currentCategory, pathname]);
  const locale = useLocale();
  return (
    <>
      <div className='mb-8 max-sm:mb-2'>
        <h2 className='text-2xl font-medium text-gray-900 max-md:text-base max-sm:text-sm'>
          {currentCategory?.name}
        </h2>

        <p className='mt-3 text-xs leading-relaxed max-lg:mt-2.5 sm:text-sm md:text-[15px] lg:text-base'>
          {currentCategory?.category_text_description}
        </p>

        {/* Image Wrapper */}
        {categoryBannerImage && (
          <div className='relative mt-6 h-[228px] w-full overflow-hidden rounded-lg max-md:mt-2.5 max-md:h-[146px]'>
            {!_hasHydrated ? (
              <div className='absolute top-0 left-0 w-full animate-pulse rounded-sm bg-gray-100 px-3' />
            ) : (
              <NextImage
                src={process.env.NEXT_PUBLIC_IMG_BASEURL + categoryBannerImage}
                alt={currentCategory?.name}
                fill
                // className='object-cover'
              />
            )}
          </div>
        )}
      </div>
      {subCategories?.length > 0 && (
        <div className='-mx-4 max-sm:mb-3'>
          <CategoriesSlider
            {...{
              data: {
                'title-en': 'BEST FOR YOUR CATEGORIES',
                'title-ar': 'الأفضل لفئاتك',
                value: subCategories,
              },
              locale,
              isMobile,
              fromCategoryPage: true,
            }}
          />
        </div>
      )}
    </>
  );
}

export default Header;
